import { apiGet } from "./api.ts";
import type { Admin } from "../types/Admin";

export async function getAdmins(): Promise<Admin[]> {
  const response = await apiGet<Admin[]>(`/admins`);
  return response;
}

export async function getAdmin(id: string): Promise<Admin> {
  return apiGet<Admin>(`/admins/${id}`);
}
